// TODO: vsavkin add SERVER_PROVIDERS and SERVER_APP_PROVIDERS
export {Parse5DomAdapter} from './src/parse5_adapter';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
